/**
 * Info banner: "Configure/Save X First" — used when a step depends on another.
 * Uses shared information card styles (soft rounded, light blue border/bg, dark grey-blue text).
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Check } from 'lucide-react';
import {
  INFO_CARD_WRAPPER,
  INFO_CARD_TITLE,
  INFO_CARD_TEXT,
  INFO_CARD_ICON_WRAPPER,
  INFO_CARD_ICON_CLASS,
} from './constants/infoCardStyles';

export function SaveFirstBanner({ title, description }) {
  return (
    <div className={`${INFO_CARD_WRAPPER} flex items-start gap-3`}>
      <div className={INFO_CARD_ICON_WRAPPER}>
        <Check className={INFO_CARD_ICON_CLASS} strokeWidth={4} aria-hidden />
      </div>
      <div>
        <h5 className={`${INFO_CARD_TITLE} mb-1`}>{title}</h5>
        <p className={INFO_CARD_TEXT}>{description}</p>
      </div>
    </div>
  );
}

SaveFirstBanner.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};
